<template>
  <div class="job-family-line-menu" data-testid="row-actions">
    <MenuIcon
      :dropdownItems="visibleMenuItems"
      :menuWidth="true"
      :showTooltip="false"
      @onClick="handleMenuClick"
    >
      <template #activator>
        <button
          type="button"
          class="job-family-line-menu__trigger"
          :aria-label="triggerLabel"
        >
          <img :src="dotsHorizontalIconSrc" alt="" width="24" height="24" aria-hidden="true" />
        </button>
      </template>
    </MenuIcon>
  </div>
</template>

<script>
export default {
  name: "JobFamilyLineMenu",
};
</script>

<script setup>
import { computed } from "vue";
import MenuIcon from "@components/MenuIcon/MenuIcon.vue";
import { rowActionsFor } from "@components/JobFamiliesList/jobFamiliesListRow.js";

const dotsHorizontalIconSrc = require("@components/assets/job-family/dots-horizontal.svg");

const props = defineProps({
  family: { type: Object, default: () => ({}) },
  status: { type: String, default: "draft" },
  positionCount: { type: Number, default: 0 },
});

const emit = defineEmits(["action"]);

const visibleMenuItems = computed(() =>
  rowActionsFor({
    status: props.status,
    positionCount: props.positionCount,
  })
);

const triggerLabel = computed(() => {
  const name = String(props.family?.name || "").trim();
  return name ? `Actions for ${name}` : "Job family actions";
});

function handleMenuClick(item) {
  if (item && item.value) {
    emit("action", { type: item.value, family: props.family });
  }
}
</script>

<style scoped>
.job-family-line-menu {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.job-family-line-menu__trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
}

.job-family-line-menu__trigger:hover {
  background: #f2f4f7;
}
</style>
